<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h1 class="card-title mb-0 flex-grow-1">Client Users</h1>
			</div>

			<div class="card-body">
				<div class="row mt-2">
					<div class="col-lg-12">
						<form class="content-filters">
							<div class="row mt-2">
								<div class="form-group col-sm-2">
									<label for="filterAlias" class="headerSearch">Select Status</label>
									<div ngbDropdown>
										<button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>
											{{ filterClient }}
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
											<button ngbDropdownItem (click)="getClientUsers(1)">Active</button>
											<button ngbDropdownItem (click)="getClientUsers(0)">Inactive</button>
										</div>
									</div>
								</div>
								<div class="form-group col-sm-6">
									<label for="filterFirst" class="headerSearch">Search</label>
									<input type="text" class="form-control" placeholder="Search" (keyup)="updateFilter2($event, 'name,alias,company_name,email1')" />
								</div>
								<div class="col-4">
									<button class="btn btn-success waves-effect waves-light rounded-pill" (click)="openModal(createUserSelection)" style="position: relative; top: 25px"><i class="ri-user-add-fill"></i> Add Client user</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>

			<div class="container">
				<div class="col-12" align="top" *ngIf="loading">
					<!-- <app-loading></app-loading> -->
				</div>
			</div>
			<br />
			<div *ngIf="!loading">
				<div class="card-body">
					<ngx-datatable #table class="table-responsive table-card material striped" [rows]="rowsClients" [columns]="columns" [loadingIndicator]="loading" [columnMode]="columnMode.force" [headerHeight]="50" [footerHeight]="70" rowHeight="auto" [reorderable]="reorderable" [scrollbarH]="true">
						<ngx-datatable-column prop="isActive" name="Active" headerClass="bg-light" [width]="30">
							<ng-template let-row="row" ngx-datatable-cell-template>
								<div align="center" class="form-check form-switch">
									<input *ngIf="row['isActive'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="deactivateUserConfirm(row)" />
									<input *ngIf="row['isActive'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="activateUserConfirm(row)" />
								</div>
							</ng-template>
						</ngx-datatable-column>

						<ngx-datatable-column prop="alias" name="Alias" headerClass="bg-light" [width]="100"></ngx-datatable-column>
						<ngx-datatable-column prop="name" name="Name" headerClass="bg-light"></ngx-datatable-column>
						<!-- <ngx-datatable-column prop="login" name="Login" headerClass="bg-light" [cellClass]="getCellClassLogin" [width]="130">
							<ng-template let-row="row" ngx-datatable-cell-template>
								<span (click)="openClientUserAdd(clientUserAdd, row['id'])"> <i class="ri-cursor-line"></i>{{ row["login"] }} </span>
							</ng-template>
						</ngx-datatable-column> -->
						<ngx-datatable-column prop="company_name" name="Company" headerClass="bg-light"></ngx-datatable-column>
						<ngx-datatable-column prop="email1" name="Email" headerClass="bg-light" [width]="200"></ngx-datatable-column>
						<ngx-datatable-column name="Options" headerClass="bg-light" [width]="50">
							<ng-template let-row="row" ngx-datatable-cell-template>
								<div align="center">
									<button class="btn btn-primary btn-sm" (click)="openEditUser(row['id'])" placement="top" ngbTooltip="Edit user"><i class="ri-edit-2-line"></i></button>
								</div>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-footer *ngIf="true" class="bg-light">
							<ng-template ngx-datatable-footer-template let-rowCount="rowCount">
								<div class="title-footer" style="margin-left: 5px"><strong>Total Records: </strong> {{ rowCount }}</div>
							</ng-template>
						</ngx-datatable-footer>
					</ngx-datatable>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal edit user -->
<ng-template #createUserSelection let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Create customer user</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body" *ngIf="!emailToCustomerSelected">
		<div class="row">
			<div class="col-6" style="text-align: center">
				<label for="">Send email to customer</label>
				<br />
				<i class="ri-mail-send-line" style="font-size: 50px"></i>
				<br />
				<button class="btn btn-primary" (click)="emailToCustomerSelected = true">Send</button>
			</div>
			<div class="col-6" style="text-align: center">
				<label for="">Use Wizard</label>
				<br />
				<i class="ri-user-shared-line" style="font-size: 50px"></i>
				<br />
				<button class="btn btn-primary" (click)="openUserWizardModal()">Use Wizard</button>
			</div>
		</div>
	</div>

	<div class="modal-body" *ngIf="emailToCustomerSelected">
		<div class="row">
			<div class="col-12" style="text-align: center">
				<p>Enter the customer email to send the email. This email contains the link an instructions to create the customer user</p>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<input type="text" [(ngModel)]="customerName" class="form-control" placeholder="Customer Name" />
			</div>
			<div class="col-6">
				<input type="email" [(ngModel)]="customerEmail" class="form-control" placeholder="Customer Email" />
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<div class="container">
			<div class="row" *ngIf="emailToCustomerSelected">
				<div class="col-6" align="left">
					<button class="btn btn-outline-secondary waves-effect waves-light" (click)="emailToCustomerSelected = false"><i class="bx bx-arrow-back"></i> Back</button>
				</div>
				<div class="col-6" align="right">
					<button class="btn btn-primary" (click)="sendEmailToCustomer()" [disabled]="loadingEmail">
						<div class="spinner-border text-light loader" role="status" *ngIf="loadingEmail">
							<span class="sr-only">Loading...</span>
						</div>
						<i class="ri-mail-send-line"></i> Send
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>